<ng-template #notification let-data="data" let-form="form" let-checkBoxName="checkBoxName" let-dataTestId="dataTestId">
  <h4 [attr.data-testid]="dataTestId + '-title'" class="font-body-1 nordic-blue-900-text mr-xsmall-y">
    {{ data.teaserTitle }}
  </h4>

  <div class="scroll grey-50-bg border font-body-1 pr-xsmall mr-xsmall-b">
    <article [style.max-height]="'15vh'" [innerHTML]="data.detailText | finSafe: 'html'"></article>
  </div>

  <fin-input-checkbox
    [labelDataTestId]="dataTestId"
    [group]="form"
    [modelName]="checkBoxName"
    [name]="checkBoxName"
    [hideError]="true"
    [labelClass]="'font-body-1 pr-xxsmall-l'"
    [translationPrefix]="'koreanPaxInfoNotification.fields.' + checkBoxName"
  ></fin-input-checkbox>
</ng-template>

<fcom-modal
  data-testid="korea-notification-modal"
  [title]="'koreanPaxInfoNotification.title' | finLocalization"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [confirmEnabled]="form.valid"
  [(open)]="modalOpen"
  (confirm)="confirmed.next()"
  (close)="close.emit()"
>
  <div class="nordic-blue-900-text pr-xxsmall-x pr-xxsmall-b" [formGroup]="form">
    <section *ngIf="useOfPersonalInformation$ | async as data">
      <ng-container
        *ngTemplateOutlet="
          notification;
          context: {
            form: form,
            data: data,
            checkBoxName: 'useOfPersonalInformation',
            dataTestId: 'korea-notification-use-of-personal-information',
          }
        "
      ></ng-container>
    </section>

    <section *ngIf="overseasTransferOfPersonalInfo$ | async as data">
      <ng-container
        *ngTemplateOutlet="
          notification;
          context: {
            form: form,
            data: data,
            checkBoxName: 'overseasTransferOfPersonalInfo',
            dataTestId: 'korea-notification-transfer-of-personal-information',
          }
        "
      ></ng-container>
    </section>
  </div>
</fcom-modal>
